var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._l(_vm.receivedattachments, function(attachment, index) {
      return _c("chat-received-attachment-component", {
        key: index,
        attrs: { attachment: attachment, index: index }
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }